var React = require('react');

function ArrowBottom (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.99971 9.56015C7.71296 9.56015 7.42624 9.45066 7.20762 9.23214L0.327982 2.35243C-0.109653 1.9148 -0.109653 1.20525 0.327982 0.767791C0.76544 0.330333 1.47485 0.330333 1.91252 0.767791L7.99971 6.85534L14.0869 0.768003C14.5246 0.330545 15.2339 0.330545 15.6713 0.768003C16.1092 1.20546 16.1092 1.91501 15.6713 2.35265L8.7918 9.23235C8.57307 9.45091 8.28636 9.56015 7.99971 9.56015Z","fill":"#BABABA"}));
}

ArrowBottom.defaultProps = {"width":"16","height":"10","viewBox":"0 0 16 10","fill":"none"};

module.exports = ArrowBottom;

ArrowBottom.default = ArrowBottom;
